import List from "./List.js";
import Edit from "./Edit.js";
import Create from "./Create.js";
import Show from "./Show.js";

export default { List, Edit, Show, Create };
